<template>
  <div class="wrapper">
    <!-- <div class="search-wrapper">
      <img class="search-btn" src="/static/img/search.png" alt>
      <input class="search-input" type="text" placeholder="关键字搜索">
    </div>-->
    <search></search>
    <div class="slide-wrapper">
      <ul>
        <li v-for="(item,index) in titleList" :key="index">
          <div
            class="first-title"
            :class="{'first-title-active':item.id ==firstFlag}"
            @click="changeFlag(item.id,item.title,item.sub)"
          >
            {{item.title}}
            <span class="circle"></span>
            <span class="jiantou" :class="{'rotate':item.id == firstFlag&&!colflag}" v-show="item.sub.length>0"></span>
          </div>
          <div class="second-wrapper" v-if="item.id == firstFlag&&colflag">
            <div class="second-inner">
              <div
                v-for="(childItem) in item.sub"
                :key="'dd'+childItem.id"
                class="second-title"
                :class="{'second-title-active':childItem.id ==secondFlag}"
                @click="changeSecondFlag(childItem.id)"
              >
                <div class="second-title-style">
                  {{childItem.title}}
                  <span class="second-circle"></span>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<style scoped>
.search-wrapper {
  width: 100%;
  height: 40px;
  background: rgba(237, 241, 244, 1);
  border: 1px solid rgba(220, 227, 233, 1);
  border-radius: 10px;
  margin-bottom: 30px;
  position: relative;
}
.search-btn {
  width: 25px;
  height: 26px;
  position: absolute;
  top: 7px;
  right: 10px;
  cursor: pointer;
}
.search-input::placeholder {
  color: #a2a8b8;
}
.search-input {
  width: 100%;
  height: 100%;
  padding: 10px 60px 10px 20px;
  box-sizing: border-box;
  outline: none;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  color: #333;
  background: rgba(237, 241, 244, 1);
}
.slide-wrapper {
  width: 310px;
  background: #e6ecf2;
  border-radius: 10px;
  padding: 20px 0;
  box-sizing: border-box;
  border: 1px solid #e6ecf2;
}
.first-title {
  width: 310px;
  height: 60px;
  line-height: 20px;
  /* display: table-cell;
  vertical-align: middle; */
  display: flex;
    justify-content: center;
  flex-direction: column;
  border-bottom: 1px solid #cdd7e2;
  color: #1e4cb0;
  font-size: 18px;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  background: #f7f7f7;
}
.jiantou {
  position: absolute;
  content: "";
  top: 0;
  right: 20px;
  width: 20px;
  height: 100%;
  background: url(/static/img/title-down-icon.png) no-repeat center center;
  background-size: 14px 10px;
}
.first-title-active .jiantou {
  background: url(/static/img/title-up-icon.png) no-repeat center center !important;
  background-size: 14px 10px;
}
.first-title .circle {
  position: absolute;
  top: 50%;
  left: 16px;
  width: 15px;
  height: 15px;
  transform: translateY(-50%);
  background: #fff;
  border: 3px solid #1e4cb0;
  border-radius: 50%;
  box-sizing: border-box;
}
.first-title-active .circle {
  background: #1e4cb0;
  border: 3px solid #ffffff;
}
.first-title-active::after {
  position: absolute;
  content: "";
  top: 0;
  right: 10px;
}
.first-title-active {
  background: url(/static/img/common-nav.png) no-repeat center center;
  background-size: 100% 60px;
  color: #fff;
}
.second-wrapper {
  overflow: hidden;
  transition: height 0.5s ease-in-out;
}
.second-title-active {
  background: #256ec8 !important;
  color: #fff;
}
.second-title .second-circle {
  position: absolute;
  top: 50%;
  left: 19px;
  width: 8px;
  height: 8px;
  transform: translateY(-50%);
  background: #dfdfdf;
  border-radius: 50%;
  box-sizing: border-box;
}
.second-title-active .second-circle {
  background: #fff;
}
.second-title {
  width: 100%;
  height: 60px;
  background: #fff;
  display: table;
  position: relative;
  padding-left: 40px;
  box-sizing: border-box;
  font-size: 16px;
  cursor: pointer;
}
.second-title-style {
  display: table-cell;
  vertical-align: middle;
  line-height: 20px;
  border-bottom: 1px solid #e6ecf2;
  padding-left: 4px;
  box-sizing: border-box;
}
.second-inner .second-title:last-child .second-title-style{
   border-bottom:none;
}
.second-title-active .second-title-style {
  border-bottom: none;
}
.rotate{
  transform: rotate(180deg);
}
</style>

<script>
import { userApi } from "@/api/user.js";
import { mapActions, mapGetters } from "vuex";
import search from "@/components/views/common/search.vue";
export default {
  data() {
    return {
      title: "",
      firstFlag: "",
      secondFlag: "",
      hei: 0,
      titleList: [],
      colflag: true //折叠控制开关
    };
  },
  components: {
    search
  },
  computed: {
    ...mapGetters(["indexSlide"])
  },
  methods: {
    ...mapActions(["setTitle"]),
    getSlideList() {
      userApi.worksperiod({type: this.$route.query.type}).then(res => {
        this.titleList = res.data;
        // if (!this.$route.query.workinfoId) {
        //   // this.firstFlag = this.titleList[0].id;
        //   // this.secondFlag = this.titleList[0].sub[0].id;
        //   // this.title = this.titleList[0].id.name;
        //   for(var i =0;i<this.titleList.length;i++){
        //     var childSub = this.titleList[i];
        //     for(var j=0;j<childSub.sub.length;j++) {
        //       if(childSub.sub[j].title =="办理流程"){
        //         this.firstFlag = childSub.id;
        //         this.secondFlag = childSub.sub[j].id;
        //         this.title = childSub.name;
        //       }
        //     }
        //   }
        //   this.$router.push({
        //     name: "BusinessIntro",
        //     query: {
        //       firstId: this.firstFlag,
        //       workinfoId: this.secondFlag,
        //       type: this.type
        //     }
        //   });
        // } else {
        //   this.firstFlag = this.$route.query.firstId;
        //   this.secondFlag = this.$route.query.workinfoId;
        //   this.type = this.$route.query.type;
        // }
        if(!this.$route.query.firstId){
          this.firstFlag = res.data[0].id;
          if(res.data[0].sub[0]){
            this.secondFlag = res.data[0].sub[0].id;
          }
        }else{
          this.firstFlag = this.$route.query.firstId;
          this.secondFlag = this.$route.query.workinfoId;
        }
        this.type = this.$route.query.type;
        this.$router.push({
            name: "BusinessIntro",
            query: {
              firstId: this.firstFlag,
              workinfoId: this.secondFlag,
              type: this.type,
              fr: !this.$route.query.firstId?'hd':''
            }
        });
      });
    },
    changeFlag(id,name,flag) {
      if(id==='41'){
        window.open('http://www.ncosm.org.cn/ncosm/portal/index#page4')
      }else if(id==='4'){
        window.open('http://www.ncosm.org.cn/ncosm/portal/index')
      }else if(id==='44'){
        window.open('http://www.ncosm.org.cn/#/linkPage')
      }else{
        if(this.firstFlag == id&&flag.length>0){
          this.colflag = !this.colflag
        }
        this.firstFlag = id;
        this.title = name;
        if(flag.length<=0){
          this.$router.push({
            name: "Redirect",
            query: {
              firstId: this.firstFlag,
              type: this.type
            }
          });
        }
      }
    },
    changeSecondFlag(id) {
      this.secondFlag = id;
      this.$router.push({
        name: "Redirect",
        query: {
          firstId: this.firstFlag,
          workinfoId: this.secondFlag,
          type: this.type
        }
      });
    },
    toPage(url) {
      this.$router.push(url);
    }
  },
  watch: {
    $route(val, oldval) {
      if (!val.query.id) {
        this.$router.push({
          name: "BusinessIntro",
          query: {
            firstId: this.firstFlag,
            workinfoId: this.secondFlag,
            type: this.type,
            fr: val.query.fr
          }
        });
      }
    }
  },
  mounted() {
    this.getSlideList();
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/BusinessWork/slide.vue